export const ERROR_PAGE = {
  TITLE: 'Error',
  UNEXPECTED_ERROR: 'There was an unexpected error',
}
